import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    setTimeout(() => {
      this.dismissFlash();
    }, 5000);
  }

  dismissFlash() {
    this.containerTarget.style.animation = 'fade-out-up 0.3s ease-out forwards'
    this.containerTarget.remove();
  }
}
